import styled, { css, SimpleInterpolation } from 'styled-components';
import ButtonReset from '../inputResets/buttonReset';
import DefaultTheme from '../../assets/styles/config';

import Media from '../../assets/styles/media';
import THEME from '../../assets/styles/config';

interface ButtonStyleProps {
  disabled?: boolean;
  isPrimary?: boolean;
  isSecondary?: boolean;
}

export const StyledButton = styled(ButtonReset)<ButtonStyleProps>`
  font-weight: bold;
  text-align: center;
  padding: 16px 0;
  width: 100%;

  ${Media.Below.tablet`
    font-size: 14px;
    padding: 12px 0;
  `}

  &:hover {
    cursor: pointer;
  }

  ${(props): SimpleInterpolation =>
    props.isPrimary &&
    css`
      color: ${THEME.colors.primaryColor};
      background-color: white;
      border: ${THEME.colors.primaryColor} 1px solid;
    `}

  ${(props): SimpleInterpolation =>
    props.isSecondary &&
    css`
      color: white;
      background-color: ${THEME.colors.primaryColor};
      border: ${THEME.colors.primaryColor} 1px solid;
    `}
`;

StyledButton.defaultProps = {
  theme: DefaultTheme,
};

export const temp = 'temp';
